import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import MerchantPaymentStatusPage from '../../container/pages/MerchantPaymentStatusPage';

/**
 * Stripe redirects here after checkout. Must render before redux-persist rehydrates auth,
 * otherwise App's logged-out /* route shows the login screen. Waits for rehydration, then
 * requires login to verify the session.
 */
function MerchantPaymentReturnRoute() {
  const rehydrated = useSelector((state) => state._persist?.rehydrated);
  const isLoggedIn = useSelector((state) => state?.auth?.login);

  if (rehydrated === false) {
    return (
      <div
        className="spin"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return <MerchantPaymentStatusPage />;
}

export default MerchantPaymentReturnRoute;
